import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "./aanandamGallery.css";
import {
  FiImage,
  FiCompass,
  FiFilm,
  FiZoomIn,
  FiPlay,
  FiVolume2,
  FiVolumeX,
  FiX,
  FiChevronLeft,
  FiChevronRight,
  FiHeart,
  FiShare2,
  FiEye,
} from "react-icons/fi";
import { toast } from "react-toastify";

const AanandamGallery = () => {
  const IMAGE_BASE_URL =
    process.env.REACT_APP_IMAGE_BASE_URL || "https://aanandam.com/image";
  const VIDEO_BASE_URL =
    process.env.REACT_APP_Video_BASE_URL || "https://aanandam.com/video";

  const location = useLocation();
  const navigate = useNavigate();

  // Active section for sticky sub-nav
  const [activeSection, setActiveSection] = useState("images");
  const [activeFilter, setActiveFilter] = useState("all");

  // Lightbox modal state for Images & Drawn Images
  const [lightboxData, setLightboxData] = useState(null); // { items: [], index: 0, type: 'image' | 'drawing' }

  // Reel modal state
  const [activeReelIndex, setActiveReelIndex] = useState(null);
  const [reelPlaying, setReelPlaying] = useState(true);
  const [reelMuted, setReelMuted] = useState(false);
  const [likedReels, setLikedReels] = useState({});
  const reelVideoRef = useRef(null);

  // Section references for intersection observer & smooth scrolling
  const imagesSectionRef = useRef(null);
  const drawnImagesSectionRef = useRef(null);
  const reelsSectionRef = useRef(null);

  // 1. DATA: 3D Render Images
  const imagesList = [
    {
      src: "Updated%20Renders%20-%20Barsana%20(1).jpg",
      title: "Grand Entrance & Royal Boulevard",
      category: "township",
      tag: "Township View",
    },
    {
      src: "Updated%20Renders%20-%20Barsana%20(4).jpg",
      title: "Luxury Living Room Interior",
      category: "interior",
      tag: "Villa Interior",
    },
    {
      src: "Updated%20Renders%20-%20Barsana%20(5).jpg",
      title: "Contemporary Master Bedroom",
      category: "interior",
      tag: "Villa Interior",
    },
    {
      src: "Updated%20Renders%20-%20Barsana%20(6).jpg",
      title: "Designer Dining & Kitchen Space",
      category: "interior",
      tag: "Villa Interior",
    },
    {
      src: "Updated%20Renders%20-%20Barsana%20(7).jpg",
      title: "Curved Villa Facade & Front Lawn",
      category: "villa",
      tag: "Villa Architecture",
    },
    {
      src: "Updated%20Renders%20-%20Barsana%20(8).jpg",
      title: "Panoramic Villa Street View",
      category: "villa",
      tag: "Villa Architecture",
    },
    {
      src: "Updated%20Renders%20-%20Barsana%20(9).jpg",
      title: "Pool Villa & Deck Lounge",
      category: "villa",
      tag: "Pool Villa",
    },
    {
      src: "Updated%20Renders%20-%20Barsana%20(10).jpg",
      title: "Modern Courtyard & Balcony",
      category: "villa",
      tag: "Villa Architecture",
    },
    {
      src: "Updated%20Renders%20-%20Barsana%20(13).jpg",
      title: "Meditation Pavilion & Water Body",
      category: "landscape",
      tag: "Landscaping",
    },
    {
      src: "Updated%20Renders%20-%20Barsana%20(15).jpg",
      title: "Clubhouse & Recreation Lawn",
      category: "township",
      tag: "Township Amenity",
    },
    {
      src: "Updated%20Renders%20-%20Barsana%20(17).jpg",
      title: "Sacred Temple Plaza & Promenade",
      category: "landscape",
      tag: "Landscaping",
    },
    {
      src: "Anandam%20township,%20Barsana-1st%20Phase-8K%20Renders%20(15).jpg",
      title: "Phase-1 Aerial Master Township",
      category: "township",
      tag: "Aerial Render",
    },
    {
      src: "Anandam%20township,%20Barsana-1st%20Phase-8K%20Renders%20(16).jpg",
      title: "Lush Green Central Park & Walkway",
      category: "landscape",
      tag: "Landscape",
    },
    {
      src: "Anandam%20township,%20Barsana-1st%20Phase-8K%20Renders%20(17).jpg",
      title: "Aanandam Valley Sunset Boulevard",
      category: "township",
      tag: "Township View",
    },
    {
      src: "Anandam%20township,%20Barsana-1st%20Phase-8K%20Renders%20(18).jpg",
      title: "Signature Villa Enclave",
      category: "villa",
      tag: "Villa Architecture",
    },
    {
      src: "Anandam%20township,%20Barsana-1st%20Phase-8K%20Renders%20(20).jpg",
      title: "Water Fountain & Interactive Plaza",
      category: "landscape",
      tag: "Landscape",
    },
    {
      src: "Anandam%20township,%20Barsana-1st%20Phase-8K%20Renders%20(21).jpg",
      title: "Children's Play Park & Elder Zone",
      category: "landscape",
      tag: "Amenities",
    },
    {
      src: "Anandam%20township,%20Barsana-1st%20Phase-8K%20Renders%20(22).jpg",
      title: "Grand Evening Township Illumination",
      category: "township",
      tag: "Evening View",
    },
    {
      src: "Updated-R2-2nd%20Stage%20Submission%20-%20Anandam%20Township,%20Barsana,%20Mathura-%203D%20views%20at%208K%20Resolution%20(20).jpg",
      title: "8K Detailed Villa Elevation",
      category: "villa",
      tag: "8K 3D View",
    },
    {
      src: "Updated-R2-2nd%20Stage%20Submission%20-%20Anandam%20Township,%20Barsana,%20Mathura-%203D%20views%20at%208K%20Resolution%20(21).jpg",
      title: "Contemporary Villa Driveway",
      category: "villa",
      tag: "Villa Architecture",
    },
    {
      src: "Updated-R2-2nd%20Stage%20Submission%20-%20Anandam%20Township,%20Barsana,%20Mathura-%203D%20views%20at%208K%20Resolution%20(22).jpg",
      title: "Township Gated Security & Boulevard",
      category: "township",
      tag: "Township View",
    },
    {
      src: "Updated-R2-2nd%20Stage%20Submission%20-%20Anandam%20Township,%20Barsana,%20Mathura-%203D%20views%20at%208K%20Resolution%20(25).jpg",
      title: "Serene Garden Pathway",
      category: "landscape",
      tag: "Landscape",
    },
    {
      src: "Updated-R2-2nd%20Stage%20Submission%20-%20Anandam%20Township,%20Barsana,%20Mathura-%203D%20views%20at%208K%20Resolution%20(27).jpg",
      title: "Open Air Amphitheatre & Greens",
      category: "landscape",
      tag: "Amenities",
    },
    {
      src: "Updated-R2-2nd%20Stage%20Submission%20-%20Anandam%20Township,%20Barsana,%20Mathura-%203D%20views%20at%208K%20Resolution%20(30).jpg",
      title: "Spiritual Reflection Pool & Pergola",
      category: "landscape",
      tag: "Landscape",
    },
  ];

  // 2. DATA: 36 Drawn Images (Only pure images for the Drawn Images Gallery)
  const drawnImagesList = [
    "img1.jpg",
    "img2.jpg",
    "img3.jpg",
    "img4.jpg",
    "img5.jpg",
    "img6.jpg",
    "img7.jpg",
    "img8.jpg",
    "img9.jpg",
    "img10.jpg",
    "img11.jpg",
    "img12.jpg",
    "img13.jpg",
    "img14.jpg",
    "img15.jpg",
    "img16.jpg",
    "img17.jpg",
    "img18.jpg",
    "img19.jpg",
    "img20.jpg",
    "img21.jpg",
    "img22.jpg",
    "img23.jpg",
    "img24.jpg",
    "img25.jpg",
    "img26.jpg",
    "img27.jpg",
    "img28.jpg",
    "img29.jpg",
    "img30.jpg",
    "img31.jpg",
    "img32.jpg",
    "img33.jpg",
    "img34.jpg",
    "img35.jpg",
    "img36.jpg",
  ];

  // 3. DATA: Reels (Vertical Video Showcase)
  const reelsList = [
    {
      id: "reel-1",
      title: "Aanandam Valley Divine Township Walkthrough",
      caption:
        "Experience 32 acres of pure tranquility in the sacred abode of Barsana. 🌿✨",
      videoSrc: `${VIDEO_BASE_URL}/radha1.mp4`,
      poster: `${IMAGE_BASE_URL}/img6.jpg`,
      duration: "0:45",
      views: "18.4K",
      likes: 1420,
      tags: ["#AanandamValley", "#Barsana", "#LuxuryTownship"],
    },
    {
      id: "reel-2",
      title: "Spiritual Morning & Sunrise Over Barsana Hills",
      caption:
        "Wake up to divine temple bells and panoramic views of sacred Brahma Hills. 🌅🦚",
      videoSrc: `${VIDEO_BASE_URL}/radha2.mp4`,
      poster: `${IMAGE_BASE_URL}/img1.jpg`,
      duration: "0:58",
      views: "24.9K",
      likes: 2180,
      tags: ["#RadhaRani", "#DivineLiving", "#BrajDham"],
    },
    {
      id: "reel-3",
      title: "Luxury Villa Living & Architecture Tour",
      caption:
        "Designed with elegance, built for serenity. Take a quick look inside. 🏡💫",
      videoSrc: `${VIDEO_BASE_URL}/radha3.mp4`,
      poster: `${IMAGE_BASE_URL}/img2.jpg`,
      duration: "1:15",
      views: "31.2K",
      likes: 3040,
      tags: ["#VillaLiving", "#ModernComforts", "#RealEstate"],
    },
    {
      id: "reel-4",
      title: "World-Class Amenities & Landscaping Tour",
      caption:
        "Over 30+ lifestyle amenities crafted by India's top landscape architects. 🏊‍♂️🧘♀️",
      videoSrc: `/video/radha4.mp4`,
      fallbackVideo: `${VIDEO_BASE_URL}/radha4.mp4`,
      poster: `${IMAGE_BASE_URL}/img9.jpg`,
      duration: "0:52",
      views: "15.7K",
      likes: 1250,
      tags: ["#TownshipLife", "#Clubhouse", "#GreenLiving"],
    },
    {
      id: "reel-5",
      title: "Connecting Braj Heritage to Modern Luxury",
      caption:
        "Just 2 km from Shri Ji Temple, seamlessly connected to Delhi NCR via Yamuna Expressway. 🚗💨",
      videoSrc: `${VIDEO_BASE_URL}/radha5.mp4`,
      poster: `${IMAGE_BASE_URL}/img16.jpg`,
      duration: "1:05",
      views: "27.5K",
      likes: 2490,
      tags: ["#BarsanaTownship", "#Investment", "#DreamHome"],
    },
  ];

  // Smooth scroll to a given section with header offset
  const scrollToSection = (sectionId, updateHash = true) => {
    const el =
      document.getElementById(`section-${sectionId}`) ||
      document.getElementById(sectionId);
    if (el) {
      const headerOffset = 90;
      const elementPosition = el.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      setActiveSection(sectionId);
      if (updateHash) {
        window.history.replaceState(null, "", `#${sectionId}`);
      }
    }
  };

  // Handle Hash on mount or when location changes
  useEffect(() => {
    const hash = location.hash.replace("#", "");
    if (hash) {
      const timer = setTimeout(() => {
        scrollToSection(hash, false);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [location.hash]);

  // ScrollSpy with IntersectionObserver
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "-20% 0px -60% 0px",
      threshold: 0,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (entry.target.id === "section-images") setActiveSection("images");
          if (entry.target.id === "section-drawn-images")
            setActiveSection("drawn-images");
          if (entry.target.id === "section-reels") setActiveSection("reels");
        }
      });
    };

    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions,
    );
    if (imagesSectionRef.current) observer.observe(imagesSectionRef.current);
    if (drawnImagesSectionRef.current)
      observer.observe(drawnImagesSectionRef.current);
    if (reelsSectionRef.current) observer.observe(reelsSectionRef.current);

    return () => observer.disconnect();
  }, []);

  // Filtered Images
  const filteredImages =
    activeFilter === "all"
      ? imagesList
      : imagesList.filter((img) => img.category === activeFilter);

  // Lightbox handlers
  const openImageLightbox = (index) => {
    setLightboxData({
      items: filteredImages,
      index,
      type: "image",
    });
  };

  const openDrawnImageLightbox = (index) => {
    setLightboxData({
      items: drawnImagesList,
      index,
      type: "drawing",
    });
  };

  const closeLightbox = () => {
    setLightboxData(null);
  };

  const nextLightboxImage = (e) => {
    e?.stopPropagation();
    if (!lightboxData) return;
    setLightboxData((prev) => ({
      ...prev,
      index: (prev.index + 1) % prev.items.length,
    }));
  };

  const prevLightboxImage = (e) => {
    e?.stopPropagation();
    if (!lightboxData) return;
    setLightboxData((prev) => ({
      ...prev,
      index: prev.index === 0 ? prev.items.length - 1 : prev.index - 1,
    }));
  };

  // Keyboard navigation for Lightbox
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (lightboxData) {
        if (e.key === "Escape") closeLightbox();
        if (e.key === "ArrowRight") nextLightboxImage();
        if (e.key === "ArrowLeft") prevLightboxImage();
      }
      if (activeReelIndex !== null) {
        if (e.key === "Escape") closeReelModal();
        if (e.key === "ArrowRight" || e.key === "ArrowDown") nextReel();
        if (e.key === "ArrowLeft" || e.key === "ArrowUp") prevReel();
        if (e.key === " ") {
          e.preventDefault();
          toggleReelPlay();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [lightboxData, activeReelIndex, reelPlaying]);

  // Reel Modal Handlers
  const openReelModal = (index) => {
    setActiveReelIndex(index);
    setReelPlaying(true);
  };

  const closeReelModal = () => {
    setActiveReelIndex(null);
  };

  const nextReel = (e) => {
    e?.stopPropagation();
    if (activeReelIndex === null) return;
    setActiveReelIndex((prev) => (prev + 1) % reelsList.length);
    setReelPlaying(true);
  };

  const prevReel = (e) => {
    e?.stopPropagation();
    if (activeReelIndex === null) return;
    setActiveReelIndex((prev) =>
      prev === 0 ? reelsList.length - 1 : prev - 1,
    );
    setReelPlaying(true);
  };

  const toggleReelPlay = () => {
    if (reelVideoRef.current) {
      if (reelPlaying) {
        reelVideoRef.current.pause();
        setReelPlaying(false);
      } else {
        reelVideoRef.current.play();
        setReelPlaying(true);
      }
    }
  };

  const toggleReelMute = (e) => {
    e?.stopPropagation();
    if (reelVideoRef.current) {
      reelVideoRef.current.muted = !reelMuted;
      setReelMuted(!reelMuted);
    }
  };

  const toggleLikeReel = (reelId, e) => {
    e?.stopPropagation();
    setLikedReels((prev) => ({
      ...prev,
      [reelId]: !prev[reelId],
    }));
  };

  const handleShareReel = (reel, e) => {
    e?.stopPropagation();
    if (navigator.share) {
      navigator
        .share({
          title: reel.title,
          text: reel.caption,
          url: `${window.location.origin}/aanandamgallery#reels`,
        })
        .catch(() => { });
    } else {
      navigator.clipboard.writeText(
        `${window.location.origin}/aanandamgallery#reels`,
      );
      toast.success("🔗 Reel link copied to clipboard!");
    }
  };

  return (
    <>
      <Header />

      <main className="aanandam-gallery-page">
        {/* HERO HEADER */}
        <section className="gallery-hero-header">
          {/* <div className="gallery-hero-overlay"></div> */}
          <div className="container position-relative z-2 text-center d-none">
            <div className="gallery-badge-pill">
              <span className="sparkle-dot"></span> Aanandam Valley Showcase
            </div>
            <h1 className="gallery-main-title">Aanandam Gallery</h1>
            <p className="gallery-main-subtitle">
              Immerse yourself in the 32-acre divine sanctuary of Barsana
              through high-resolution 3D renders, architectural drawings, and
              short experience reels.
            </p>

            {/* Quick Stats */}
            <div className="gallery-quick-stats">
              <div
                className="stat-pill"
                onClick={() => scrollToSection("images")}
              >
                <FiImage className="stat-icon" />
                <span>
                  <strong>{imagesList.length}+</strong> 3D Renders
                </span>
              </div>
              <div
                className="stat-pill"
                onClick={() => scrollToSection("drawn-images")}
              >
                <FiCompass className="stat-icon" />
                <span>
                  <strong>{drawnImagesList.length}</strong> Drawn Images
                </span>
              </div>
              <div
                className="stat-pill"
                onClick={() => scrollToSection("reels")}
              >
                <FiFilm className="stat-icon" />
                <span>
                  <strong>{reelsList.length}</strong> Experience Reels
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* STICKY CATEGORY SUB-NAV */}
        <div className="sticky-gallery-subnav-container">
          <div className="container">
            <div className="sticky-gallery-subnav">
              <button
                className={`subnav-tab ${activeSection === "images" ? "active" : ""}`}
                onClick={() => scrollToSection("images")}
              >
                <FiImage className="tab-icon" />
                <span>Images</span>
                <span className="tab-count">{imagesList.length}</span>
              </button>

              <button
                className={`subnav-tab ${activeSection === "drawn-images" ? "active" : ""}`}
                onClick={() => scrollToSection("drawn-images")}
              >
                <FiCompass className="tab-icon" />
                <span>Drawn Images</span>
                <span className="tab-count">{drawnImagesList.length}</span>
              </button>

              <button
                className={`subnav-tab ${activeSection === "reels" ? "active" : ""}`}
                onClick={() => scrollToSection("reels")}
              >
                <FiFilm className="tab-icon" />
                <span>Reels</span>
                <span className="tab-count">{reelsList.length}</span>
              </button>
            </div>
          </div>
        </div>

        {/* ============================================================ */}
        {/* 1. SECTION: IMAGES */}
        {/* ============================================================ */}
        <section
          id="section-images"
          ref={imagesSectionRef}
          className="gallery-section-block section-images-block"
        >
          <div className="container">
            {/* Section Header */}
            <div className="section-head-wrap text-center">
              <div className="section-category-tag">
                <FiImage className="me-1" /> 3D Architecture & Views
              </div>
              <h2 className="section-title">Township & Villa Images</h2>
              <p className="section-desc">
                High-definition 3D visualizations showcasing the elegance of
                Aanandam Valley villas, grand boulevards, water features, and
                manicured green landscapes.
              </p>

              {/* Filter Tabs */}
              <div className="image-filter-pills">
                <button
                  className={`filter-btn ${activeFilter === "all" ? "active" : ""}`}
                  onClick={() => setActiveFilter("all")}
                >
                  All Renders ({imagesList.length})
                </button>
                <button
                  className={`filter-btn ${activeFilter === "township" ? "active" : ""}`}
                  onClick={() => setActiveFilter("township")}
                >
                  Township Views
                </button>
                <button
                  className={`filter-btn ${activeFilter === "villa" ? "active" : ""}`}
                  onClick={() => setActiveFilter("villa")}
                >
                  Villas & Exterior
                </button>
                <button
                  className={`filter-btn ${activeFilter === "interior" ? "active" : ""}`}
                  onClick={() => setActiveFilter("interior")}
                >
                  Interiors
                </button>
                <button
                  className={`filter-btn ${activeFilter === "landscape" ? "active" : ""}`}
                  onClick={() => setActiveFilter("landscape")}
                >
                  Landscapes & Parks
                </button>
              </div>
            </div>

            {/* Images Grid */}
            <div className="row g-4 gallery-images-grid">
              {filteredImages.map((img, index) => (
                <div
                  className="col-xl-3 col-lg-4 col-md-6 col-12 gallery-card-col"
                  key={`img-${index}-${img.src}`}
                >
                  <div
                    className="gallery-image-card"
                    onClick={() => openImageLightbox(index)}
                  >
                    <div className="image-wrapper">
                      <img
                        src={`${IMAGE_BASE_URL}/${img.src}`}
                        alt={img.title}
                        loading="lazy"
                        className="img-fluid gallery-thumb"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `/image/${img.src.replace(/%20/g, " ")}`;
                        }}
                      />
                      <div className="card-hover-overlay">
                        <span className="card-tag-badge">{img.tag}</span>
                        <div className="overlay-center-btn">
                          <FiZoomIn className="zoom-icon" />
                        </div>
                        <div className="overlay-bottom-info">
                          <h4 className="card-image-title">{img.title}</h4>
                          <span className="click-to-view">
                            Click to view in HD
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ============================================================ */}
        {/* 2. SECTION: DRAWN IMAGES (Clean Pure Image Gallery) */}
        {/* ============================================================ */}
        <section
          id="section-drawn-images"
          ref={drawnImagesSectionRef}
          className="gallery-section-block section-drawn-block"
        >
          <div className="container">
            {/* Section Header */}
            <div className="section-head-wrap text-center">
              <div className="section-category-tag blueprint-tag">
                <FiCompass className="me-1" /> Drawn Gallery
              </div>
              <h2 className="section-title">Drawn Images</h2>
            </div>

            {/* Drawn Images Grid - Pure Image Focus with Hover & Lightbox */}
            <div className="row g-3 g-md-4 drawn-images-pure-grid">
              {drawnImagesList.map((fileName, index) => (
                <div
                  className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-6 drawn-pure-col"
                  key={`drawn-${index}`}
                >
                  <div
                    className="drawn-pure-card"
                    onClick={() => openDrawnImageLightbox(index)}
                  >
                    <div className="drawn-img-wrap">
                      <img
                        src={`${IMAGE_BASE_URL}/${fileName}`}
                        alt={`Drawn Image ${index + 1}`}
                        loading="lazy"
                        className="drawn-pure-img"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `/image/${fileName.replace(/%20/g, " ")}`;
                        }}
                      />
                      <div className="drawn-hover-mask">
                        <div className="drawn-hover-zoom-icon">
                          <FiZoomIn />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ============================================================ */}
        {/* 3. SECTION: REELS */}
        {/* ============================================================ */}
        <section
          id="section-reels"
          ref={reelsSectionRef}
          className="gallery-section-block section-reels-block"
        >
          <div className="container">
            {/* Section Header */}
            <div className="section-head-wrap text-center">
              <div className="section-category-tag reels-tag">
                <FiFilm className="me-1" /> Immersive Video Experience
              </div>
              <h2 className="section-title">Aanandam Valley Reels</h2>
              <p className="section-desc">
                Short, engaging video highlights capturing the spiritual
                essence, architectural grandeur, and serene lifestyle at
                Aanandam Valley Barsana.
              </p>
            </div>

            {/* Reels Grid (9:16 vertical cards) */}
            <div className="row g-4 reels-grid justify-content-center">
              {reelsList.map((reel, index) => (
                <div
                  className="col-xl-2-4 col-lg-4 col-md-6 col-sm-6 col-12 reel-card-col"
                  key={reel.id}
                >
                  <div
                    className="reel-card-item"
                    onClick={() => openReelModal(index)}
                  >
                    <div className="reel-thumbnail-wrap">
                      <img
                        src={reel.poster}
                        alt={reel.title}
                        className="reel-poster-img"
                        loading="lazy"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `${IMAGE_BASE_URL}/Updated%20Renders%20-%20Barsana%20(1).jpg`;
                        }}
                      />
                      <div className="reel-gradient-overlay"></div>

                      {/* Top Header Badge */}
                      <div className="reel-card-top-bar">
                        <span className="reel-icon-pill">
                          <FiFilm className="me-1" /> Reel
                        </span>
                        <span className="reel-duration-pill">
                          {reel.duration}
                        </span>
                      </div>

                      {/* Center Play Button */}
                      <div className="reel-play-btn-wrapper">
                        <div className="reel-play-btn">
                          <FiPlay className="play-icon" />
                        </div>
                      </div>

                      {/* Sound Wave Animation indicator */}
                      <div className="reel-audio-bars">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>

                      {/* Bottom Info Overlay */}
                      <div className="reel-card-bottom-info">
                        <div className="reel-stats-row">
                          <span className="reel-views">
                            <FiEye className="me-1" /> {reel.views}
                          </span>
                          <span
                            className={`reel-likes ${likedReels[reel.id] ? "liked" : ""}`}
                            onClick={(e) => toggleLikeReel(reel.id, e)}
                          >
                            <FiHeart className="me-1" />{" "}
                            {reel.likes + (likedReels[reel.id] ? 1 : 0)}
                          </span>
                        </div>
                        <h4 className="reel-item-title">{reel.title}</h4>
                        <div className="reel-tags-wrap">
                          {reel.tags.slice(0, 2).map((t, idx) => (
                            <span key={idx} className="reel-single-tag">
                              {t}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ============================================================ */}
        {/* LIGHTBOX MODAL (Images & Drawings) */}
        {/* ============================================================ */}
        {lightboxData && (
          <div className="gallery-lightbox-overlay" onClick={closeLightbox}>
            <div
              className="gallery-lightbox-modal"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                className="lightbox-close-btn"
                onClick={closeLightbox}
                aria-label="Close"
              >
                <FiX />
              </button>

              {/* Prev Button */}
              <button
                className="lightbox-nav-btn prev-btn"
                onClick={prevLightboxImage}
                aria-label="Previous Image"
              >
                <FiChevronLeft />
              </button>

              {/* Image Content Container */}
              <div className="lightbox-content-area">
                {(() => {
                  const currentItem = lightboxData.items[lightboxData.index];
                  const currentSrc =
                    typeof currentItem === "string"
                      ? currentItem
                      : currentItem.src;
                  const currentTitle =
                    typeof currentItem === "object" ? currentItem.title : "";
                  const currentSubtitle =
                    typeof currentItem === "object"
                      ? currentItem.subtitle || currentItem.tag
                      : "";

                  return (
                    <>
                      <img
                        src={`${IMAGE_BASE_URL}/${currentSrc}`}
                        alt={
                          currentTitle ||
                          `Gallery Image ${lightboxData.index + 1}`
                        }
                        className="lightbox-main-img"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `/image/${currentSrc.replace(/%20/g, " ")}`;
                        }}
                      />

                      {/* Bottom Caption Bar */}
                      <div className="lightbox-caption-bar">
                        <div className="caption-text-wrap">
                          {currentTitle ? (
                            <>
                              <h3 className="caption-title">{currentTitle}</h3>
                              {currentSubtitle && (
                                <p className="caption-desc">
                                  {currentSubtitle}
                                </p>
                              )}
                            </>
                          ) : (
                            <h3 className="caption-title">
                              Drawn Image {lightboxData.index + 1}
                            </h3>
                          )}
                        </div>
                        <div className="caption-counter">
                          {lightboxData.index + 1} / {lightboxData.items.length}
                        </div>
                      </div>
                    </>
                  );
                })()}
              </div>

              {/* Next Button */}
              <button
                className="lightbox-nav-btn next-btn"
                onClick={nextLightboxImage}
                aria-label="Next Image"
              >
                <FiChevronRight />
              </button>
            </div>
          </div>
        )}

        {/* ============================================================ */}
        {/* REELS VIDEO PLAYER MODAL */}
        {/* ============================================================ */}
        {activeReelIndex !== null && (
          <div className="reel-modal-overlay" onClick={closeReelModal}>
            <div
              className="reel-modal-container"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                className="reel-close-btn"
                onClick={closeReelModal}
                aria-label="Close Reel"
              >
                <FiX />
              </button>

              {/* Prev Reel Button */}
              <button
                className="reel-side-nav-btn prev-reel"
                onClick={prevReel}
                aria-label="Previous Reel"
              >
                <FiChevronLeft />
              </button>

              {/* Vertical Reel Video Wrapper */}
              <div className="reel-player-wrapper">
                <video
                  ref={reelVideoRef}
                  src={reelsList[activeReelIndex].videoSrc}
                  className="reel-active-video"
                  autoPlay
                  loop
                  playsInline
                  muted={reelMuted}
                  onClick={toggleReelPlay}
                  onError={(e) => {
                    if (reelsList[activeReelIndex].fallbackVideo) {
                      e.target.src = reelsList[activeReelIndex].fallbackVideo;
                    }
                  }}
                />

                {/* Big Center Play/Pause indicator on click */}
                {!reelPlaying && (
                  <div
                    className="reel-center-pause-indicator"
                    onClick={toggleReelPlay}
                  >
                    <FiPlay />
                  </div>
                )}

                {/* Reel Top Bar Controls */}
                <div className="reel-player-top-bar">
                  <div className="reel-user-badge">
                    <img
                      src="./image/logooo.png"
                      alt="Aanandam Valley"
                      className="reel-avatar"
                      onError={(e) => {
                        e.target.src = `${IMAGE_BASE_URL}/logooo.png`;
                      }}
                    />
                    <div>
                      <h5 className="reel-author">Aanandam Valley</h5>
                      <span className="reel-location">Barsana, Mathura</span>
                    </div>
                  </div>

                  <div className="reel-top-actions">
                    <button
                      className="reel-action-icon-btn"
                      onClick={toggleReelMute}
                      title={reelMuted ? "Unmute" : "Mute"}
                    >
                      {reelMuted ? <FiVolumeX /> : <FiVolume2 />}
                    </button>
                  </div>
                </div>

                {/* Reel Floating Side Actions (Like, Share) */}
                <div className="reel-floating-side-actions">
                  <button
                    className={`reel-side-action-btn ${likedReels[reelsList[activeReelIndex].id] ? "active" : ""
                      }`}
                    onClick={(e) =>
                      toggleLikeReel(reelsList[activeReelIndex].id, e)
                    }
                  >
                    <FiHeart />
                    <span>
                      {reelsList[activeReelIndex].likes +
                        (likedReels[reelsList[activeReelIndex].id] ? 1 : 0)}
                    </span>
                  </button>

                  <button
                    className="reel-side-action-btn"
                    onClick={(e) =>
                      handleShareReel(reelsList[activeReelIndex], e)
                    }
                  >
                    <FiShare2 />
                    <span>Share</span>
                  </button>
                </div>

                {/* Reel Bottom Caption & Tags */}
                <div className="reel-player-bottom-bar">
                  <h3 className="reel-playing-title">
                    {reelsList[activeReelIndex].title}
                  </h3>
                  <p className="reel-playing-caption">
                    {reelsList[activeReelIndex].caption}
                  </p>
                  <div className="reel-playing-tags">
                    {reelsList[activeReelIndex].tags.map((t, idx) => (
                      <span key={idx} className="reel-tag-item">
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* Next Reel Button */}
              <button
                className="reel-side-nav-btn next-reel"
                onClick={nextReel}
                aria-label="Next Reel"
              >
                <FiChevronRight />
              </button>
            </div>
          </div>
        )}
      </main>

      <Footer />
    </>
  );
};

export default AanandamGallery;
